import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { type RootState } from '@redux/store';

import { H1, StringXSmall } from '@/components/Typography/Typography';
import { Level } from '@/components/ui/Level/Level';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import coinStarPng from '/img/coin-star.png';
import coinStarWebp from '/img/coin-star.webp';

const MainBackground: React.FC = () => {
  const { user, extendedInfo } = useSelector((state: RootState) => state.user);
  const { t } = useTranslation();

  return (
    extendedInfo && (
      <div className={css.head}>
        <div className="flex w-full flex-col items-center">
          <div className="relative w-20 h-20 shrink-0">
            <img
              src={user?.photoUrl}
              className="avatarSettings"
              alt=""
              width={'100%'}
            />
            <div className={css.elipse}></div>
            <img
              className={css.starsImage}
              src="/img/modals/level-up-pattern.png"
              alt="stars"
            />
          </div>
          <Level
            className="-translate-y-1/2"
            variant="default"
            value={extendedInfo.level}
          />
          <StringXSmall weight="medium" className="!text-white/40">
            {t('Empire Capitalization')}
          </StringXSmall>
          <div className="flex items-center gap-1 mb-4">
            <Picture
              className="w-8 h-8 shrink-0"
              img={coinStarPng}
              webp={coinStarWebp}
              alt="capitalization"
            />
            <H1 weight="bold" className="!leading-[100%]">
              {toShortNumFormat(extendedInfo?.totalEmpireValue || 0)}
            </H1>
          </div>
          {/* <div className="infoSettings">
            <span>{t('Empire value')}</span>
            <p>
              <picture>
                <source srcSet="/img/icons/cash.webp" type="image/webp" />
                <img src="/img/icons/cash.png" alt="icon" width={32} />
              </picture>
              {toShortNumFormat(extendedInfo?.totalEmpireValue)}
            </p>
          </div> */}
          {/* <div className="progressSettings">
            <div className="progress-bar-settings">
              <div className="steps">
                {Array.from({ length: 10 }).map((_, index) => (
                  <div
                    key={index}
                    className="step"
                    style={{
                      backgroundColor:
                        index < (extendedInfo?.level || 0)
                          ? 'var(--main-primary, #82e024)'
                          : '',
                    }}
                  ></div>
                ))}
              </div>
            </div>

            <span>{t('Complete tasks and level up')}</span>
          </div> */}
        </div>
      </div>
    )
  );
};

export default MainBackground;
